import { FC } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LoadingSpinner from "@/presentation/ui/components/common/LoadingSpinner";
import AuthService from "@/core/services/Auth.service";

const AuthCheck: FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoading, getAccessTokenSilently } = useAuth0();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  AuthService.getInstance().setAccessTokenSilentlyFunction(getAccessTokenSilently);

  return children;
};

export default AuthCheck;
